import { useFetchers } from "@website/fetcher/use-fetcher";
import { ReserveCommentPropertiesType } from "@website/widget/reserve-comment";
import { useRouter } from "next/router";
import { useCallback, useEffect, useRef, useState } from "react";
import { fetchHotelReviewData } from "./index.server";

export const useHotelComments = (properties: {
  hotelId: number;
  roomId: number;
}) => {
  const router = useRouter();
  const initialFilters = {
    attitude:
      String(
        router.query?.["filter_attitude"] === "all"
          ? ""
          : router.query?.["filter_attitude"] ?? ""
      ) || ""
  };
  const { hotelId, roomId } = properties;
  const total = useRef(0);
  const page = useRef(1);
  const [pages, setPages] = useState<Array<number>>([1]);
  const [filters, setFilters] =
    useState<Record<string, string>>(initialFilters);

  const commentsQueries = useFetchers({
    queries: pages?.map((page) => ({
      queryKey: ["hotelReviewData", hotelId, page, "villa", filters, roomId],
      queryFn: ({ queryKey }: { queryKey: Array<unknown> }) =>
        fetchHotelReviewData(
          queryKey[1],
          queryKey[2],
          String(queryKey[3]),
          queryKey[4] as Record<string, string>
        )
    }))
  });

  useEffect(() => {
    page.current = commentsQueries.flatMap(({ data }) => data?.page)?.[
      commentsQueries.length - 1
    ];
    total.current = commentsQueries.flatMap(({ data }) => data?.total)?.[
      commentsQueries.length - 1
    ];
  }, [commentsQueries]);

  const onLoadMore = useCallback(() => {
    if (page.current < Math.ceil(total.current / 5))
      setPages((previousState) => [...previousState, page.current + 1]);
  }, []);

  const onLoadFilter = useCallback((filter: Record<string, string>) => {
    if (filter?.["attitude"] === "all") filter["attitude"] = "";
    setFilters((previousState) => ({ ...previousState, ...filter }));
  }, []);

  return {
    onLoadMore,
    onLoadFilter,
    filters: initialFilters,
    comments:
      (commentsQueries.flatMap(
        ({ data }) => data?.rateReviews || []
      ) as unknown as Array<ReserveCommentPropertiesType>) || [],
    isLoading: commentsQueries.some((item) => item.isFetching)
  };
};
